module.exports = __webpack_public_path__ + "static/media/dub-svetlii.545df6bf.jpg";